<script lang="ts">
	import step1 from "@assets/images/step1.png?webp";
	import step2 from "@assets/images/step2.png?webp";
	import step3 from "@assets/images/step3.png?webp";
	import BuyCampfireLink from "@components/BuyCampfireLink.svelte";
	import Step from "@components/Step.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
</script>

<section class="grid-container bg-nov-light-100 full-width">
	<h2 class="font-bold text-center">Jak to funguje?</h2>
	<div class="[counter-reset:step-list] flex flex-col items-center lg:flex-row justify-stretch gap-4 lg:gap-0 xs:my-4">
		<Step
			title="Přenosné ohniště složíte za minutu. Bez nářadí"
			description="Vytáhnete z obalu, zacvaknete konstrukci – hotovo. Žádné šrouby a dlouhé manuály."
			image={{ src: step1, type: "image/webp" }}
		/>
		<Step
			title="Postavíte kamkoliv. Oheň zůstane pod kontrolou"
			description="Na trávu, terasu i kámen. Stabilní, bezpečné a šetrné k podkladu. Popel zůstává uvnitř."
			image={{ src: step2, type: "image/webp" }}
		/>
		<Step
			title="Rozložíte, vezmete s sebou a pokračujete dál"
			description="Jednoduše složíte do obalu a auto zůstane čisté. A vy jste připraveni na další zážitky."
			image={{ src: step3, type: "image/webp" }}
		/>
	</div>
	<BuyCampfireLink variant={ButtonVariant.Primary} class="w-fit mx-auto mt-8 lg:mt-14 mb-2" />
</section>
